
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-2",attrs:{"d":"M19.206 7.539v-.007l-.007-.01a.17.17 0 00-.015-.018 1.39 1.39 0 00-1.072-.5H6.892a1.386 1.386 0 00-1.07.5l-.01.011-.013.019a1.378 1.378 0 00-.295.855v7.477a1.394 1.394 0 001.392 1.393h11.215a1.394 1.394 0 001.393-1.393V8.389a1.378 1.378 0 00-.298-.85zm-1.278.377l-4.451 3.665a1.608 1.608 0 01-1.955 0L7.071 7.916zm.656 7.953a.477.477 0 01-.477.477H6.892a.477.477 0 01-.477-.477v-7.3l.015.013 4.533 3.727a2.52 2.52 0 003.071 0l4.549-3.739z"}})])
          )
        }
      }
    